import WIS from './WIS';
import moreRequestData from './moreRequestData';

const root = {
	WIS,
	moreRequestData
};

export default root;
